import { defineStore } from "pinia";
import type { IFilterStore, TLocalFilter } from "./types";
import { IDateRange } from "@/core/composables/F360DateShortcuts/types";
export const idStore = "localFilterIndicadores";

export const useLocalFilterStore = defineStore(idStore, {
  state: (): IFilterStore => ({
    localFilters: [],
    shortcutsFilters: []
  }),
  actions: {
    setFilter(filters: TLocalFilter[]) {
      this.localFilters = filters;
    },
    saveFilter(value: TLocalFilter, shortcut?: number) {
      const { id } = value;
      const isFilterExists = this.getFilterById(id);
      if (!isFilterExists) {
        this.localFilters.push(value);

        if (shortcut != undefined) {
          this.updateShortcut(id, shortcut);
        }

        return;
      }
      this.clearFilter(id);
      this.localFilters.push(value);

      if (!shortcut) return;

      this.updateShortcut(id, shortcut);
    },
    updateShortcut(id: string | number, value: number, range?: IDateRange) {
      const hasShortcut = this.getShortcutFilterById(id);

      if (!hasShortcut) {
        this.shortcutsFilters?.push({ id, shortcutSelecionado: value, range });

        return;
      }

      hasShortcut.shortcutSelecionado = value;

      if (range !== undefined) {
        hasShortcut.range = range;
      }
    },
    clearFilter(id: number) {
      const newFilters = this.localFilters.filter((f) => f.id !== id);
      this.setFilter(newFilters);
    },
    getFilterById(id: number) {
      const filter = this.localFilters.find((filter) => {
        return filter.id === id;
      });

      return filter;
    },
    getShortcutFilterById(id: string | number) {
      const filter = this.shortcutsFilters?.find((filter) => {
        return filter.id == id;
      });

      return filter;
    }
  }
});
